import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { currencyOptions } from 'constants/loanFee';
import { formatNumberToCurrencyString } from 'utils/number';

import { getHeadLabelStyles } from '../Label.styles';

const TotalAmount = ({ value, isPending = false }) => {
  return (
    <Typography sx={getHeadLabelStyles({ isPending })} variant="regular14">
      Total: {formatNumberToCurrencyString(value || 0, currencyOptions)}
    </Typography>
  );
};

TotalAmount.propTypes = {
  isPending: PropTypes.bool,
  value: PropTypes.number,
};

export default TotalAmount;
